/**
 * Press Section - Infinite scroll on mobile
 */

class PressScroll {
  constructor(section) {
    this.section = section;
    this.track = section.querySelector('[data-press-track]');
    this.content = section.querySelector('[data-press-content]');
    this.speed = parseFloat(this.track?.dataset.speed) || 1;

    if (this.track && this.content) {
      this.init();
    }
  }

  init() {
    this.calculateAnimationDuration();
    this._resizeHandler = () => this.calculateAnimationDuration();
    window.addEventListener('resize', this._resizeHandler);
  }

  calculateAnimationDuration() {
    const contentWidth = this.content.offsetWidth;
    const baseDuration = contentWidth / 50;
    const duration = baseDuration / this.speed;
    this.track.style.animationDuration = `${duration}s`;
  }

  destroy() {
    if (this._resizeHandler) {
      window.removeEventListener('resize', this._resizeHandler);
    }
  }
}

function initPressSections() {
  const sections = document.querySelectorAll('[data-section-type="w-press"]');
  sections.forEach(section => {
    if (!section.pressScrollInstance) {
      section.pressScrollInstance = new PressScroll(section);
    }
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initPressSections);
} else {
  initPressSections();
}

if (window.Shopify && window.Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector('[data-section-type="w-press"]');
    if (section) {
      section.pressScrollInstance = new PressScroll(section);
    }
  });

  document.addEventListener('shopify:section:unload', (event) => {
    const section = event.target.querySelector('[data-section-type="w-press"]');
    if (section && section.pressScrollInstance) {
      section.pressScrollInstance.destroy();
      section.pressScrollInstance = null;
    }
  });
}

window.PressScroll = PressScroll;
